import { render } from "./HistoryFolder.vue?vue&type=template&id=4df82ba8&scoped=true"
import script from "./HistoryFolder.vue?vue&type=script&lang=js"
export * from "./HistoryFolder.vue?vue&type=script&lang=js"

import "./HistoryFolder.vue?vue&type=style&index=0&id=4df82ba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df82ba8"]])

export default __exports__